import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { GiTreeBranch, GiMeditation, GiHeartBeats } from 'react-icons/gi';
import '../styles/AboutSerene1.css';

const AboutSerene = () => {
    const [redirecting, setRedirecting] = useState(false);
    const [isMobileTablet, setIsMobileTablet] = useState(
        typeof window !== "undefined" ? window.innerWidth <= 991 : false
    );

    useEffect(() => {
        const onResize = () => setIsMobileTablet(window.innerWidth <= 991);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const handleRedirect = () => {
        setRedirecting(true);
        setTimeout(() => {
            window.location.href = "https://vessella.com/palms-masterplan/";
        }, 900);
    };

    const fadeUp = {
        hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
        show: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: { duration: 0.45, ease: "easeOut" },
        },
    };

    const infoBlocks = [
        {
            icon: <GiHeartBeats className="feature-icon" size={isMobileTablet ? 52 : 40} />,
            title: "Refined Way of Living",
            body: (
                <p
                    className={`text-muted small mb-0 lh-lg ${isMobileTablet ? "text-start" : "text-center"}`}
                    style={isMobileTablet ? { fontSize: "clamp(0.9rem, 4.2vw, 1.1rem)", lineHeight: 1.6 } : undefined}
                >
                    We don’t just build homes, we shape experiences. Thoughtfully designed villas bring refined architecture and nature into effortless harmony. Every space is purposeful, every detail considered, creating a lifestyle that feels intimate, elegant, and enduring.
                </p>
            ),
        },
        // {
        //     icon: <GiMeditation className="feature-icon" size={isMobileTablet ? 52 : 40} />,
        //     title: "Key Highlights",
        //     body: (
        //         <div
        //             className={`d-flex flex-column gap-1 ${isMobileTablet ? "mt-1" : "mt-3"}`}
        //             style={isMobileTablet ? { fontSize: "clamp(0.9rem, 4.2vw, 1.1rem)", lineHeight: 1.5 } : undefined}
        //         >
        //             <span className="fw-semibold text-secondary">72 Luxury Villas</span>
        //             <span className="fw-semibold text-secondary">8.71 Acres of Green Space</span>
        //             <span className="fw-semibold text-secondary">3 & 4 BHK units</span>
        //             <span className="fw-semibold text-secondary">Kismatpur Location</span>
        //         </div>
        //     ),
        // },
        {
            icon: <GiTreeBranch className="feature-icon" size={isMobileTablet ? 52 : 40} />,
            title: " Location Defined by Calm",
            body: (
                <p
                    className={`text-muted small mb-0 lh-lg ${isMobileTablet ? "text-start" : "text-center"}`}
                    style={isMobileTablet ? { fontSize: "clamp(0.9rem, 4.2vw, 1.1rem)", lineHeight: 1.6 } : undefined}
                >
                    Located within one of Hyderabad’s fastest-evolving residential corridors, it strikes the perfect balance between nature, accessibility, and future growth, surrounded by premium developments and essential infrastructure.
                </p>
            ),
        },
    ];

    return (
        <>
            <section
                className={`about-serene-section container-fluid ${isMobileTablet ? "about-serene-mobile" : ""}`}
                id="about-serene"
            >
                <div
                    className={`container position-relative d-flex flex-column ${isMobileTablet ? "justify-content-start about-serene-mobile-container" : " justify-content-center pb-5"}`}
                >


                    <div
                        className={`green-text-part col-lg-5 col-md-7 h-100 ${isMobileTablet ? "mobile-hero-panel" : ""}`}
                    >
                        <div
                            className={`green-branding-box text-white ${isMobileTablet ? "mobile-branding-box" : "p-5"}`}
                        >
                            {/* Header Text */}
                            <div className="mb-4">
                                <h1
                                    className={`display-3 mb-2 font-serif ${isMobileTablet ? "mobile-hero-title" : ""}`}
                                >
                                    Designed for <br /> peaceful living
                                </h1>
                                <p
                                    className={`fst-itlic fs-3 fw-light mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    72 Luxury Villas
                                </p>
                                <p
                                    className={`fst-itlic fs-3 fw-light mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    8.71 Acres of Green Space
                                </p>
                                <p
                                    className={`fst-itlic fs-3 fw-light mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    3 & 4 BHK units
                                </p>
                                <p
                                    className={`fst-itlic fs-3 fw-light mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    Kismatpur Location
                                </p>

                            </div>

                            <motion.a
                                onClick={handleRedirect}
                                className="location-btn d-inline-flex align-items-center px-4 py-2"
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, amount: 0.6 }}
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.96 }}
                                style={{ color: "#fff", border: "1px solid rgba(255,255,255,0.72)", textDecoration: "none", borderRadius: "0" }}
                            >
                                <span className={`text-uppercase small letter-spacing-2 me-2 ${isMobileTablet ? "mobile-hero-cta-text" : ""}`}>Explore Floor Plans</span>
                                <i className={`fa-solid fa-arrow-right ${isMobileTablet ? "mobile-hero-cta-icon" : ""}`}></i>
                            </motion.a>
                        </div>
                    </div>


                    {/* Main Info Card */}
                    <div
                        className={`main-info-card glass-panel shadow-lg mt-auto ${isMobileTablet ? "mobile-info-card" : "p-5"}`}
                    >
                        <div className='row align-items-center'>
                            {infoBlocks.map((item, index) => (
                                <div
                                    key={item.title}
                                    className={`col-lg-6 px-4 mb-4 mb-lg-0 ${!isMobileTablet && index < 2 ? "border-end-lg" : ""} ${isMobileTablet ? "mobile-info-block d-flex align-items-start" : "text-center"}`}
                                >
                                    <div className={`${isMobileTablet ? "flex-shrink-0" : "mb-3"}`}>
                                        {item.icon}
                                    </div>
                                    <div className={`${isMobileTablet ? "flex-grow-1" : ""}`}>
                                        <h5
                                            className={`mb-2 fw-bold text-dark ${isMobileTablet ? "mobile-info-title text-start" : ""}`}
                                        >
                                            {item.title}
                                        </h5>
                                        {item.body}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

            </section>

            <AnimatePresence>
                {redirecting && (
                    <motion.div
                        className="fullscreen-transition"
                        initial={{ scaleY: 0 }}
                        animate={{ scaleY: 1 }}
                        transition={{ duration: 0.4, ease: [0.77, 0, 0.175, 1] }}
                    />
                )}
            </AnimatePresence>
        </>
    );
};

export default AboutSerene;
